import { render, staticRenderFns } from "./OpenActivitySignList.vue?vue&type=template&id=5c0604c0"
import script from "./OpenActivitySignList.vue?vue&type=script&lang=js"
export * from "./OpenActivitySignList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports